import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';
import GenericModal from '../GenericComponents/GenericModal';
import genericStyles from '../GenericComponents/GenericStyles.module.css';
import '../CC/CC';

function Footer() {
  const { t } = useTranslation();
  const [isContactModalVisible, setIsContactModalVisible] = useState(false);
  const [isAproposModalVisible, setIsAproposModalVisible] = useState(false);
  const [isCreditsModalVisible, setIsCreditsModalVisible] = useState(false);
  const emailRef = useRef<HTMLInputElement>(null);
  const commentsRef = useRef<HTMLTextAreaElement>(null);

  const handleSendCommentsClick = async () => {
    const emailValue = emailRef.current?.value || '';
    const commentsValue = commentsRef.current?.value || '';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email is valid
    if (!emailRegex.test(emailValue)) {
      alert(t('invalid_email'));
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SENDMAIL_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `email=${encodeURIComponent(emailValue)}&comments=${encodeURIComponent(commentsValue)}`,
      });

      if (response.ok) {
        const result = await response.text();
        alert(result); // or handle the result as needed
        setIsContactModalVisible(false)
      } else {
        alert('Error sending email.');
      }
    } catch (error: any) {
      if (error instanceof Error) {
        alert('Error: ' + error.message);
      } else {
        alert('An error occurred.');
      }
    }
  };

  return (
    <div className={styles.Footer}>
      <div className={styles.iconContainer}>
        <a href="https://www.quaibranly.fr/fr/handicap-moteur" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon1}></span>
        </a>
        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-visuel" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon2}></span>
        </a>
        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-auditif" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon3}></span>
        </a>
        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-mental" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon4}></span>
        </a>
        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/public-lsf" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon5}></span>
        </a>
      </div>
      <div className={styles.socials}>
        <a href="https://linktr.ee/mediathequequaibranly" target="_blank">
          <div className={styles.linktree}></div>
        </a>
        <a href="https://www.facebook.com/museeduquaibranlyjacqueschirac" target="_blank">
          <div className={styles.facebook}></div>
        </a>
        <a href="http://twitter.com/quaibranly" target="_blank">
          <div className={styles.twitter}></div>
        </a>
        <a href="https://instagram.com/quaibranly" target="_blank">
          <div className={styles.instagram}></div>
        </a>
      </div>

      <div className={styles.contactlinks}>
        <div className={styles.contact} onClick={() => setIsContactModalVisible(true)}> - Contact</div>
        <div className={styles.apropos} onClick={() => setIsAproposModalVisible(true)}> - A propos</div>
        <div className={styles.credits} onClick={() => setIsCreditsModalVisible(true)}> - Crédits</div>
      </div>

      <GenericModal
        title="Contact"
        isVisible={isContactModalVisible}
        onClose={() => setIsContactModalVisible(false)}
        width='40%'
      >
        <div>
          <p>{t("contact_use_form_below")}</p>
          <div>
            <div style={{ marginTop: '20px' }}>
              <div style={{ marginBottom: '8px' }}>{t("contact_emailaddress")}:</div>
              <input className={styles.footerInput} type="email" name="emailAddress" ref={emailRef} required />
            </div>
            <div style={{ marginTop: '20px' }}>
              <div style={{ marginBottom: '8px' }}>{t("contact_comments")}:</div>
              <textarea className={styles.footerTextarea} name="comments" rows={10} ref={commentsRef} required></textarea>
            </div>
            <div className={styles.formButtons}>
              <button className={genericStyles.GenericButton} onClick={handleSendCommentsClick}>{t("contact_send")}</button>
              <button className={genericStyles.GenericButton} onClick={() => setIsContactModalVisible(false)}>{t("contact_cancel")}</button>
            </div>
          </div>
        </div>
      </GenericModal>

      <GenericModal
        title="A propos"
        isVisible={isAproposModalVisible}
        onClose={() => setIsAproposModalVisible(false)}
        width='40%'
      >
        <div>
          A propos info goes here.
        </div>
      </GenericModal>

      <GenericModal
        title="Crédits"
        isVisible={isCreditsModalVisible}
        onClose={() => setIsCreditsModalVisible(false)}
        width='40%'
      >
        <div style={{ fontFamily: 'Arial, sans-serif' }}>
          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Etablissement public du musée du quai Branly – Jacques Chirac:</div>
          <p><strong>Emmanuel KASARHÉROU</strong>: Président de l’établissement public du musée du quai Branly -Jacques Chirac</p>
          <p><strong>Jérôme BASTIANELLI</strong>: Directeur général délégué</p>
          <p><strong>Anne-Solène ROLLAND</strong>: Directrice du patrimoine et des collections</p>
          <p><strong>Lucile GRAND</strong>: Directrice adjointe du patrimoine et des collections – Responsable de la Médiathèque</p>

          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Chef de projet:</div>
          <p><strong>Bertrand LEWDEN</strong>, Responsable des systèmes informatisés de la Médiathèque</p>

          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Administration des données:</div>
          <p><strong>Carine PELTIER-CAROFF</strong>, Responsable de l’iconothèque</p>
          <p><strong>Claire-Marie BARREAU</strong>, Responsable du pôle inventaire et gestion informatisée des collections</p>
          <p><strong>Thomas CONVENT</strong>, Administrateur de la base de données TMS</p>

          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Équipe projet:</div>
          <p><strong>Paul-Emmanuel BERNARD</strong>, Responsable de la bibliothèque & Adjoint de la directrice de la Médiathèque</p>
          <p><strong>Julien BRACHHAMMER</strong>, Bibliothécaire assistant spécialisé, chargé de médiation et diffusion numérique</p>
          <p><strong>Camille GRUPPO</strong>, Responsable de l’accueil des publics et de la communication des documents</p>

          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Réalisation graphique et technique:</div>
          <p><strong>CIT (Collections Information Technology)</strong>: Frans BRIDIE, Brik DE ZWART, Arthur HANSELMAN, Julien HOFFMANN, Wout VAN WEZEL</p>
        </div>

      </GenericModal>


    </div>
  );
}

export default Footer;
